import { sessionState } from 'src/app/core/services/signal-state.storage';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { transformIntoApiCallObj } from 'src/app/gdo/gdo-shared/Models/Constants';
import { SupPlan } from 'src/app/gdo/gdo-shared/Models/Interfaces';
import { packageCardDetails } from 'src/app/gdo/gdo-shared/Models/Models';

@Component({
  selector: 'app-gdo-select-subscription',
  templateUrl: './gdo-select-subscription.component.html',
  styleUrls: ['./gdo-select-subscription.component.scss'],
  standalone: false
})
export class GdoSelectSubscriptionComponent implements OnInit {
  @Input() type = '';
  @Input() title = '';
  @Input() subsForm!: UntypedFormGroup;
  @Input() currentSelectedPackage!: packageCardDetails;
  public selectedPlans: packageCardDetails[] = [];
  currentSubscribedList: packageCardDetails[] = [];
  setborder: any;
  isAcura: boolean = false;

  initialForm: UntypedFormGroup = new UntypedFormGroup({
    availablePackageSelection: new UntypedFormControl(''),
  });



  constructor(private appService: AppService, private router: Router) { }

  ngOnInit(): void {

    let currentPackageDetail = this.appService.getCurrentPackgDetails() //trial,3year,5year
    let isCurrentAvailable = (this.currentSelectedPackage && this.currentSelectedPackage.duration) ? true : false
    let upcomingPlanDuration = currentPackageDetail.upcomingPlanDuration;

    this.getSubscriptionMethods();
    this.setIsAcuraLocally()
  }

  setIsAcuraLocally() {
    let vehicleData = sessionState.getItem("vehicleMake");
    if (vehicleData) {
      vehicleData = vehicleData.toLowerCase();
      if (vehicleData == 'acura') {
        this.isAcura = true;
      }
    }
  }

  onPackageSelected() {
    const selection = this.subsForm
      .get('packageDetails')
      ?.get('availablePackageSelection');
    selection?.markAsTouched();
    selection?.updateValueAndValidity();
  }

  getSubscriptionMethods() {
    let data = {
      include_all_rate_schedules: true,
    };
    data = transformIntoApiCallObj(
      data,
      'get_client_plans_all_m'
    );
    // NOTE: TODO replace following aria pass connect api with wrapper once wrapper returns all information
    this.appService.AriaPassThroughConnect(data).subscribe((res) => {

      if (res && res.error_code === 0) {
        // modify the following these according to gdo
        let plan: any;
        let clientMasterPlanId = sessionState.getItem('clientMasterPlanId')

        // IF THE SELECTED PKG BELONGS TO GDO SO UPDATE VARIABLES
        let clientRateScheduleId_GDO_3Year = (clientMasterPlanId == 'Connected_Products_US') ? "GDO_US_3YEAR" : '';
        let clientRateScheduleId_GDO_5Year = (clientMasterPlanId == 'Connected_Products_US') ? "GDO_US_5YEAR" : '';


        // now check if the required plan is the one we selected
        let planInfo = res.all_client_plan_dtls;
        for (const iterator of planInfo) {
          if (iterator.parent_plans) {
            if (
              iterator.parent_plans[0].client_parent_plan_id == clientMasterPlanId
            ) {
              plan = iterator;
            }
          }
          if (plan) break
        }

        // Gdo 3 year subscription
        let scheduleNo_Gdo_3YearAnnual: any;
        let availableDate_Gdo_3YearAnnual: any;

        // Gdo 5 year subscription
        let scheduleNo_Gdo_5YearAnnual: any;
        let availableDate_Gdo_5YearAnnual: any;

        // check the available packages from the plan and update
        // we will have 3 conditions in loop as we have 3 packages for gdo at the moment
        for (const iterator of plan.plan_rate_schedules_details) {


          /*
           * Trial:
           * Renew:
           * Purchase Subscription:
           *  all these conditions means we can buy any pkg (3 or 5 years)
           *  - show all 3 and 5 year packages
           *
           * Change subscription:
           *  3 year can not be changes to 3 year so opposite will show
           *  - current pkg is 3 year or upcoming is 3 year: show 5 year packages
           *  - current pkg is 5 year or upcoming is 5 year: show 3 year packages
           */

          //  we are not on a 3 year package then add it to the bundle
          if (iterator.client_rate_schedule_id == clientRateScheduleId_GDO_3Year
            // && !this.isCurrent_3Year
          ) {
            scheduleNo_Gdo_3YearAnnual = iterator.schedule_no;
            availableDate_Gdo_3YearAnnual = iterator.available_from_dt;
          }

          //  we are not on a 5 year package then add it to the bundle
          else
            if (iterator.client_rate_schedule_id == clientRateScheduleId_GDO_5Year
              // && !this.isCurrent_5Year
            ) {
              scheduleNo_Gdo_5YearAnnual = iterator.schedule_no;
              availableDate_Gdo_5YearAnnual = iterator.available_from_dt;
            }

        }

        let rate: any;
        let duration: string = '';
        let subsStartDate: Date;
        let currentPlanExpiryDate: Date;
        let subscriptionStartDate: string = '';
        let allPlans = plan.plan_services[0].all_plan_service_rates;

        if (this.currentSelectedPackage?.subsExpiryDate) { currentPlanExpiryDate = new Date(this.currentSelectedPackage?.subsExpiryDate) }
        else { currentPlanExpiryDate = new Date(); }

        // confirm with Arshad, if pkg exists, then start date should be equal to expiry date
        if (this.currentSelectedPackage?.packageTitle) {
          subsStartDate = currentPlanExpiryDate;
          if (this.currentSelectedPackage?.subsExpiryDate) {
            let resetPin = sessionState.getItem("showResetPin")
            // resetPin/createPIN will always be true only when user coming from Purchase flow
            if (resetPin == "false") {
              subsStartDate = this.evaluateStartDate(this.currentSelectedPackage, currentPlanExpiryDate);
            } else {
              subsStartDate = this.evaluateStartDate(this.currentSelectedPackage, currentPlanExpiryDate);
            }
          }
        }
        else {
          subsStartDate = new Date();
          subsStartDate.setDate(new Date().getDate() + 1);
        }



        // Go through all plans and set the packages accordingly for selection
        for (const iterator of allPlans) {

          // check if slection is 5 years package
          if (iterator.schedule_no == scheduleNo_Gdo_5YearAnnual) {
            duration = '5 Year';
            subscriptionStartDate = this.formatDate(subsStartDate)
            rate = iterator.plan_service_rates[0].rate_per_unit;
          }
          else if (iterator.schedule_no == scheduleNo_Gdo_3YearAnnual) {
            duration = '3 Year';
            subscriptionStartDate = this.formatDate(subsStartDate)
            rate = iterator.plan_service_rates[0].rate_per_unit;

          }

          // we are not checking if there is trial as that wont be available for selection in spPlan
          if (iterator.schedule_no == scheduleNo_Gdo_3YearAnnual || iterator.schedule_no == scheduleNo_Gdo_5YearAnnual) {

            let subsSelectedPackage = this.appService.getSubsSelectedPackage()
            let spPlan: packageCardDetails = {
              packageTitle: plan.plan_name,
              packageDescription: plan.plan_desc,
              packagePrice: iterator.plan_service_rates[0].rate_per_unit,
              duration: duration,
              subsStartDate: subscriptionStartDate,
              subsExpiryDate: null,
              isCurrent: false,
              isEarlyBird: false
            };
            if (subsSelectedPackage) {
              if (
                subsSelectedPackage.duration == spPlan.duration
                && subsSelectedPackage.isCurrent == spPlan.isCurrent
                && subsSelectedPackage.packagePrice == spPlan.packagePrice
                && subsSelectedPackage.packageTitle == spPlan.packageTitle
                && subsSelectedPackage.subsStartDate == spPlan.subsStartDate) { spPlan.isSelected = true }
            }
            this.selectedPlans.push(spPlan);
          }
        }

      }
    });
  }


  onCancel() {
    sessionState.setItem("planType", "notearlybird")
    if (this.type) {
      this.router.navigate(['/gdoWV'], { replaceUrl: true });
    } else {
      this.router.navigate(['/gdo-product'], { replaceUrl: true });
    }
  }

  evaluateStartDate(
    curretPackage: packageCardDetails,
    currentPlanExpiryDate: string | number | Date
  ): Date {

    // Existing 3 Year / 5 Year condition
    if (
      curretPackage &&
      (curretPackage.duration === '3 Year' ||
        curretPackage.duration === '5 Year') &&
      this.getMonthDifference(currentPlanExpiryDate) >= 1
    ) {
      return new Date();
    }

    // Today's date - ignore current time
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // --------------------------------------------------
    // Cancellation Scenario:
    // If Cancellation Date is today
    // Result: Today
    // --------------------------------------------------

 const status = this.appService.getSelectedSp()?.suppPlanInstanceStatus;
    if (status == 'Cancelled') {
      return new Date(today);
    }

    // Convert expiry date to a local Date
    let expiryDate: Date;

    if (currentPlanExpiryDate instanceof Date) {
      expiryDate = new Date(currentPlanExpiryDate.getTime());

    } else if (typeof currentPlanExpiryDate === 'number') {
      expiryDate = new Date(currentPlanExpiryDate);

    } else {
      const [datePart, timePart = '00:00:00'] =
        currentPlanExpiryDate.split(' ');

      const [month, day, year] =
        datePart.split('/').map(Number);

      const [hours = 0, minutes = 0, seconds = 0] =
        timePart.split(':').map(Number);

      expiryDate = new Date(
        year,
        month - 1,
        day,
        hours,
        minutes,
        seconds
      );
    }

    // Ignore time when comparing calendar dates
    expiryDate.setHours(0, 0, 0, 0);

    // --------------------------------------------------
    // Scenario 1:
    // Expiry date is before today
    // Result: Today
    // --------------------------------------------------
    if (expiryDate < today) {
      return new Date(today);
    }

    // --------------------------------------------------
    // Scenario 2:
    // Expiry date is today
    // Result: Tomorrow
    // --------------------------------------------------
    if (expiryDate.getTime() === today.getTime()) {
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);

      return tomorrow;
    }

    // --------------------------------------------------
    // Scenario 3:
    // Expiry date is in the future
    // Result: Expiry Date + 1 day
    // --------------------------------------------------
    const nextDay = new Date(expiryDate);
    nextDay.setDate(nextDay.getDate() + 1);

    return nextDay;
  }


  getMonthDifference(date: string | number | Date) {
    const currentDate = new Date()
    var expiryDate = new Date(date);
    return (
      (expiryDate.getMonth() -
        currentDate.getMonth()) +
      (12 * (expiryDate.getFullYear() - currentDate.getFullYear()))
    );
  }

  //month starts from 0 so incrementing 1 in month
  formatDate(date: string | number | Date) {
    return ((new Date(date).getMonth() + 1) +
      '/' +
      new Date(date).getDate() +
      '/' +
      new Date(date).getFullYear())
  }



  controlChange(val: any) {
    // 
    // if (val !== this.setBorder) {
    this.setborder = val;
    // } else {
    // this.setBorder = -1;
    // }
  }


  trackBySubscriptionPlan(index: number, subscription: packageCardDetails): string | number {
    return `${subscription?.packageTitle || ''}-${subscription?.duration || ''}-${subscription?.subsStartDate || index}`;
  }



  getHeaderStyles() {
    if (this.type) {

      return "title-container font-14 text-sub-color-3 font-weight-500"
    }

    return "title-container font-14 text-sub-color-3 font-weight-400"
  }

}
